import React from "react"

export const DokumentationDerVergabeakteIcon = (props) => {
  return (
    <svg
      width={35}
      height={25}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m10.605 3.214.265.42H34.1V24.1H.9V.9h8.25l1.455 2.314Z"
        stroke="#035470"
        strokeWidth={1.8}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3h5.262l1.553 2.508H32V22H3V3Z"
        fill="#FFD62E"
      />
      <path
        d="m13.816 14.858 1.859 1.524 5.305-4.606"
        stroke="#035470"
        strokeWidth={1.8}
        strokeLinecap="square"
      />
    </svg>
  )
}
